/* ============================================================
   Colour Swatches Behaviour
   File: assets/colour-swatches.js
   - Single-select per swatch group
   - Updates hidden input, label pill, and bottom summary
   - Edge-aware tooltip positioning
   - Blocks add-to-cart until all required swatches chosen
   ============================================================ */

(function () {
  'use strict';

  var TOOLTIP_GAP = 8;
  var TOOLTIP_TIMEOUT = 1400;
  var EDGE_PADDING = 8;

  /* ---------- Tooltip positioning ---------- */
  function positionTooltip(btn) {
    var label = btn.getAttribute('data-tooltip') || '';
    var width = measureTooltipWidth(label);
    var height = 26;

    var rect = btn.getBoundingClientRect();
    var viewportW = document.documentElement.clientWidth;

    var place = 'top';
    if (rect.top - height - TOOLTIP_GAP < 0) place = 'bottom';

    var topPx, bottomPx, arrowTopPx, arrowBottomPx;
    if (place === 'top') {
      bottomPx = (rect.height + TOOLTIP_GAP) + 'px';
      topPx = 'auto';
      arrowBottomPx = (rect.height + TOOLTIP_GAP - 5) + 'px';
      arrowTopPx = 'auto';
    } else {
      topPx = (rect.height + TOOLTIP_GAP) + 'px';
      bottomPx = 'auto';
      arrowTopPx = (rect.height + TOOLTIP_GAP - 5) + 'px';
      arrowBottomPx = 'auto';
    }

    var swatchCentreX = rect.left + rect.width / 2;
    var tooltipLeftViewport = swatchCentreX - width / 2;
    var tooltipRightViewport = swatchCentreX + width / 2;

    var shift = 0;
    if (tooltipLeftViewport < EDGE_PADDING) {
      shift = EDGE_PADDING - tooltipLeftViewport;
    } else if (tooltipRightViewport > viewportW - EDGE_PADDING) {
      shift = (viewportW - EDGE_PADDING) - tooltipRightViewport;
    }

    var leftRelative = (rect.width / 2) - (width / 2) + shift;
    var arrowRelative = rect.width / 2;

    btn.style.setProperty('--tt-left', leftRelative + 'px');
    btn.style.setProperty('--tt-top', topPx);
    btn.style.setProperty('--tt-bottom', bottomPx);
    btn.style.setProperty('--tt-arrow', arrowRelative + 'px');
    btn.style.setProperty('--tt-arrow-top', arrowTopPx);
    btn.style.setProperty('--tt-arrow-bottom', arrowBottomPx);
    btn.style.setProperty('--tt-translate', place === 'top' ? '4px' : '-4px');
    btn.setAttribute('data-place', place);
  }

  var _mirror;
  function measureTooltipWidth(text) {
    if (!_mirror) {
      _mirror = document.createElement('span');
      _mirror.style.cssText = [
        'position:absolute','visibility:hidden','white-space:nowrap',
        'font-size:12px','font-weight:500','padding:6px 9px',
        'line-height:1','left:-9999px','top:-9999px','font-family:inherit'
      ].join(';');
      document.body.appendChild(_mirror);
    }
    _mirror.textContent = text;
    return _mirror.offsetWidth;
  }

  /* ---------- Selection completeness ---------- */
  function getSwatchForm() {
    var props = document.querySelector('.swatch-properties');
    return props ? props.closest('form') : null;
  }

  function checkComplete() {
    var props = document.querySelector('.swatch-properties');
    if (!props) return true;

    var inputs = props.querySelectorAll('input[type="hidden"][required]');
    var allFilled = true;
    inputs.forEach(function (input) {
      if (!input.value || input.value.trim() === '') allFilled = false;
    });

    var summary = document.querySelector('.swatch-summary');
    if (summary) summary.classList.toggle('is-complete', allFilled);

    var form = getSwatchForm();
    if (form) {
      var btns = form.querySelectorAll('[type="submit"], [name="add"], button.add-to-cart, .product-form__cart-submit, .shopify-payment-button button');
      btns.forEach(function (btn) {
        btn.disabled = !allFilled;
        if (!allFilled) {
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('swatch-locked');
        } else {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('swatch-locked');
        }
      });
    }
    return allFilled;
  }

  /* ---------- Init placeholders + first lock ---------- */
  function init() {
    document.querySelectorAll('.swatch-selected').forEach(function (el) {
      var ph = el.getAttribute('data-placeholder');
      if (ph && el.textContent.trim() === ph) {
        el.setAttribute('data-empty', 'true');
      }
    });
    checkComplete();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-check periodically in case the theme re-enables the add-to-cart button
     (some themes toggle disabled when variants change). */
  setInterval(function () {
    var props = document.querySelector('.swatch-properties');
    if (props) checkComplete();
  }, 500);

  /* ---------- Hover / focus tooltip positioning ---------- */
  document.addEventListener('mouseenter', function (e) {
    var btn = e.target.closest && e.target.closest('.colour-swatches .swatch');
    if (!btn) return;
    positionTooltip(btn);
  }, true);

  document.addEventListener('focusin', function (e) {
    var btn = e.target.closest && e.target.closest('.colour-swatches .swatch');
    if (!btn) return;
    positionTooltip(btn);
  });

  /* ---------- Click: select swatch ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.colour-swatches .swatch');
    if (!btn) return;
    e.preventDefault();

    var list = btn.closest('.colour-swatches');
    var targetId = list.getAttribute('data-target');
    var value = btn.getAttribute('data-value');

    list.querySelectorAll('.swatch.is-selected').forEach(function (s) {
      s.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');

    var input = document.getElementById(targetId);
    if (input) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    var readout = document.querySelector('.swatch-selected[data-for="' + targetId + '"]');
    if (readout) {
      readout.textContent = value;
      readout.removeAttribute('data-empty');
    }

    var summary = document.querySelector('.swatch-summary__value[data-summary-for="' + targetId + '"]');
    if (summary) {
      summary.textContent = value;
      summary.removeAttribute('data-empty');
    }

    checkComplete();

    positionTooltip(btn);
    document.querySelectorAll('.swatch.show-tooltip').forEach(function (s) {
      if (s !== btn) s.classList.remove('show-tooltip');
    });
    btn.classList.add('show-tooltip');
    clearTimeout(btn._tooltipTimer);
    btn._tooltipTimer = setTimeout(function () {
      btn.classList.remove('show-tooltip');
    }, TOOLTIP_TIMEOUT);
  }, true);

  /* ---------- Block all "add to cart" attempts ---------- */
  function blockIfIncomplete(e) {
    var form = e.target.closest && e.target.closest('form');
    if (!form) return;
    if (!form.querySelector('.swatch-properties')) return;
    if (checkComplete()) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    var firstEmpty = form.querySelector('.swatch-properties input[type="hidden"][required][value=""]');
    if (!firstEmpty) {
      // also handle inputs whose value is whitespace
      var allInputs = form.querySelectorAll('.swatch-properties input[type="hidden"][required]');
      allInputs.forEach(function (i) {
        if (!firstEmpty && (!i.value || !i.value.trim())) firstEmpty = i;
      });
    }
    if (firstEmpty) {
      var item = firstEmpty.closest('.item');
      var label = item && item.querySelector('.swatch-label');
      if (label) {
        label.scrollIntoView({ behavior: 'smooth', block: 'center' });
        label.classList.add('swatch-label--error');
        setTimeout(function () {
          label.classList.remove('swatch-label--error');
        }, 2500);
      }
    }
    return false;
  }

  // Capture phase so we run before the theme's own listeners
  document.addEventListener('submit', blockIfIncomplete, true);
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[type="submit"], [name="add"], button.add-to-cart, .product-form__cart-submit, .shopify-payment-button button');
    if (!trigger) return;
    var form = trigger.closest('form');
    if (!form || !form.querySelector('.swatch-properties')) return;
    if (!checkComplete()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      var firstEmpty = form.querySelector('.swatch-properties input[type="hidden"][required][value=""]');
      if (firstEmpty) {
        var item = firstEmpty.closest('.item');
        var label = item && item.querySelector('.swatch-label');
        if (label) {
          label.scrollIntoView({ behavior: 'smooth', block: 'center' });
          label.classList.add('swatch-label--error');
          setTimeout(function () { label.classList.remove('swatch-label--error'); }, 2500);
        }
      }
    }
  }, true);

  /* ---------- Reposition tooltips on scroll/resize ---------- */
  function repositionVisible() {
    document.querySelectorAll('.colour-swatches .swatch:hover, .colour-swatches .swatch.show-tooltip, .colour-swatches .swatch:focus-visible').forEach(positionTooltip);
  }
  window.addEventListener('scroll', repositionVisible, { passive: true });
  window.addEventListener('resize', repositionVisible);
})();